import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Container,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  // useTheme,
} from "@mui/material";
import {
  getOrganization,
  selectOrganization,
} from "../features/organization/organizationSlice";
import { getCameras } from "../features/cameras/cameraSlice";
import { EventsTable } from "../features/events/EventsTable";
import { EventsTableWWF } from "../features/events/EventsTableWWF";
import { LineChart } from "../features/linechart/LineChart";
import { PieChart } from "../features/piechart/PieChart";

export default function Dashboard() {
  const dispatch = useDispatch();
  // const theme = useTheme();
  const organization = useSelector(selectOrganization);

  useEffect(() => {
    dispatch(getOrganization());
    dispatch(getCameras());
  }, [dispatch]);

  const organizationName = organization?.name || "";
  const EventComponent =
    organizationName === "CVGL" ? EventsTable : EventsTableWWF;

  // Gradient styles
  const gradientBackground =
    "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)";

  return (
    <Box sx={{ p: 0, m: 0 }}>
      <Box sx={{ p: 0, m: 0 }}>
        <Box sx={{ p: 0, m: 0 }}>
          <Box sx={{ ml: 0, mt: 0, p: 0 }}>
            {/* Header */}
            <Paper
              className="header"
              sx={{
                background: gradientBackground,
                padding: "5px 10px",
                color: "#ecf0f1",
                mx: 0.5,
                mt: 0,
                borderRadius: "15px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              }}
            >
              <Container sx={{ p: 0 }}>
                <Typography
                  variant="h4"
                  sx={{
                    m: 0,
                    fontWeight: "bold",
                    color: "#ffffff",
                    textAlign: "center",
                    letterSpacing: "0.5px",
                  }}
                >
                  Dashboard
                </Typography>
              </Container>
            </Paper>

            {/* Content */}
            <Box sx={{ p: 0, m: 0 }}>
              <Container maxWidth={false} sx={{ p: 0 }}>
                {/* Charts Row - Side by Side */}
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <Card
                      sx={{
                        mb: 0,
                        background:
                          "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                        borderRadius: "15px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        overflow: "hidden",
                        height: "100%",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
                        },
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            mb: 1.5,
                            color: "#454545",
                            fontWeight: 600,
                          }}
                        >
                          Detection Trends
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "300px",
                          }}
                        >
                          <Box sx={{ width: "100%", height: "100%" }}>
                            <LineChart />
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Card
                      sx={{
                        mb: 0,
                        background:
                          "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                        borderRadius: "15px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        overflow: "hidden",
                        height: "100%",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
                        },
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            mb: 1.5,
                            color: "#454545",
                            fontWeight: 600,
                          }}
                        >
                          Detection Distribution
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "300px",
                          }}
                        >
                          <Box sx={{ width: "100%", height: "100%" }}>
                            <PieChart />
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                {/* Events Table with Filters inside */}
                <Box sx={{ p: 0.5, mt: 0.5 }}>
                  {EventComponent && <EventComponent />}
                </Box>
              </Container>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
